import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Select from 'react-select';
import {
    Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, CardBody, Form,
    FormGroup, Label, Input, Col
} from 'reactstrap';
import { connect } from 'react-redux'
import withRouter from '../../../../withRouter';
import { DropDownSelect } from '../Dropdown/index';
import * as caseCreateActions from '../actions'
import * as StringConst from '../../constants'
import { selectedList, disabled } from './helper'
import Modal from '../../../../components/UI/Modal/Modal'
import TableView from '../../Table/index';
import AddCounterPartyForm from '../AddCounterPartyForm'
import { Preloading } from '../../../../components/UI/Preloader/action';
import { toast } from 'react-toastify';
import * as caseCreateAction from '../../../../Analyst/Cases/Create/actions';
import { fetchIsMisOrderIdMandatoryByCorporateId } from '../../../../Admin/Corporate/Create/action';
import { COUNTRY } from '../../../../constants';

import './styles.css';

class CaseCreateForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true,
            showModal: false,
            body: "",
            input: "",
            dropdownOpen: false,
            select: "",
            isUser: false,
            searchSelected: null,
            search: "",
            submitted: false,
            inputField: "",
            productDisabled: true,
            products: [],
            selectedCountry: '',
            resizeZIndex: false,
            selectedProductCategory:null,
         

           
        };
        this.kycRequestType = StringConst.EKYC;
        this.isKycRequest = false;
        this.data = [];
        this.newProp = "";
        this.newProduct = "";
        this.status = "";
        this.error = "";
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
    }

    componentDidMount() {
        this.props.getCounterpartyType();
        this.props.getZone();
        
    }
    toggle = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }))
    }
    onhandleSelected = (e) => {
        this.setState({
            select: e.target.value
        });
        this.searchPlaceholder = "Search " + e.target.value;
    }

    handleCreateCase = () => {
        this.props.history.push(`/case/view/${this.props.result.data.caseId}`)
    }

    handleCreateCounterparty = () => {
        this.props.change('counterparty', this.props.createdCounterParty.counterpartyName);
    }
    handleSubmitError = () => {
        this.setState((prevState) => ({
            submitted: !prevState.submitted
        }))
        this.handleModal()
    }

    componentDidUpdate(prevProps) {
        const { formValues } = this.props
        if (formValues.values && formValues !== prevProps.formValues) {
            if (prevProps.formValues.values && prevProps.formValues.values.corporate &&
                formValues.values.corporate !== prevProps.formValues.values.corporate) {
                this.props.initialize({
                    "corporate": formValues.values.corporate,
                    "requestedBy": null,
                    "counterparty": null,
                    "counterpartytype": null,
                    "product": null,
                    "zone": null,
                    "caseType": StringConst.DOMESTIC
                })
                this.setState({
                    productDisabled: true
                })
            } else if (formValues.values.counterpartytype && formValues.values.corporate && this.state.selectedProductCategory) {
                if (!prevProps.formValues.values.counterpartytype) {
                    this.props.preloading(true)
                    this.props.getProducts(this.props.selectedCorp.id, formValues.values.counterpartytype, this.state.selectedProductCategory)
                } else if (formValues.values.counterpartytype !== prevProps.formValues.values.counterpartytype) {
                    this.props.preloading(true)
                    this.props.getProducts(this.props.selectedCorp.id, formValues.values.counterpartytype,this.state.selectedProductCategory)
                }
                else if (formValues.values.counterparty !== prevProps.formValues.values.counterparty) {
                    this.props.preloading(true)
                    this.props.getProducts(this.props.selectedCorp.id, formValues.values.counterpartytype,this.state.selectedProductCategory)
                }
            } if (formValues.values.product && this.newProduct !== formValues.values.product) {
                let product = selectedList(this.props.products, formValues.values.product)
                this.props.selectedProduct(product)
            }
            if (formValues.values.corporate && this.props.isMisOrderIdMandatory == undefined) {
                this.props.fetchIsMisOrderIdMandatoryByCorporateId(this.props.selectedCorp.id);
            }
            
        }

        if (!this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            this.handleModal();
            this.setState({
                submitted: true,
                modalTitle: "Success",
                body: <div className="modal-body">
                    <h5 className="text-success"><i className="fa fa-check-circle"></i>&nbsp;Success</h5>
                    <h5>Case Successfully Created!</h5>
                    <Button color="secondary" onClick={this.handleCreateCase}>View</Button>
                </div>
            })

        }
        else if (this.props.result.error && this.props.result !== prevProps.result) {
            this.props.preloading(false)
            this.handleModal();
            this.setState({
                submitted: true,
                modalTitle: "Error",
                body: <div className="modal-body">
                    <h5 className="text-danger"><i className="fa fa-exclamation-triangle">&nbsp;</i>Error</h5>
                    <h5>Error in Creating Case!</h5>
                    <h5>{(this.props.result.error.response && this.props.result.error.response.data) ? this.props.result.error.response.data.message : "Something went wrong! Please try again."}</h5>
                    <Button color="secondary" onClick={this.handleSubmitError}>OK</Button>
                </div>
            })
        }
        if (!this.props.createdCounterParty.error && this.props.createdCounterParty.length !== 0 && this.props.createdCounterParty !== prevProps.createdCounterParty){
            this.props.preloading(false)
            this.setState({
                submitted: true
            }, () => {
                this.handleCreateCounterparty();
                toast.success(
                    <div>
                        <i className="fa fa-check"></i>&nbsp;Counterparty created successfully
                    </div>
                );
            })
            this.props.getZoneForState(this.props.createdCounterParty.state);
            this.props.counterparty[0]= this.props.createdCounterParty;
            this.props.counterparty[0].cinNo=this.props.createdCounterParty.cinNumber
            this.setProductCategory();
        }
        else if (this.props.createdCounterParty.error && this.props.createdCounterParty !== prevProps.createdCounterParty) {

            this.handleModal();
            this.setState({
                submitted: true
            }, () => {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Error in Creating Counterparty!!! {(this.props.createdCounterParty.error.response && this.props.createdCounterParty.error.response.data) ? this.props.createdCounterParty.error.response.data.message : "Something went wrong! Please try again."}
                    </div>
                );
            })

        }
        if (this.props.products !== prevProps.products) {
            this.setState({
                productDisabled: false,
                products: this.props.products
            }, () => { this.props.preloading(false) })
        }
        if (this.props.productsFailure !== prevProps.productsFailure) {
            this.setState({
                productDisabled: false,
            }, () => { this.props.preloading(false) })
        }
        if (this.props.counterparty !== prevProps.counterparty) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
        }
        if (this.props.corporate !== prevProps.corporate) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
        }
        if (this.props.users !== prevProps.users) {
            this.setState({ resizeZIndex: false })
            this.props.preloading(false)
        }
    }

    handleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            search: "",
            selectedCountry: '',
            disabled: true
        }))


    }
    handleInputChange = (e) => {
        const searchValue = e.target.value;
        const isInternationalCounterpartySearch = this.props.formValues && this.props.formValues.values &&
            this.props.formValues.values.caseType === StringConst.INTERNATIONAL &&
            this.state.searchSelected === StringConst.COUNTER_PARTY_LABEL;

        this.setState({
            search: searchValue,
            disabled: isInternationalCounterpartySearch ? !searchValue.trim() : disabled(searchValue),
            [e.target.name]: searchValue
        })

    }

    handleCountryChange = (selectedCountry) => {
        this.props.resetCounterpartyPagination();
        this.setState({
            selectedCountry,
            disabled: !this.state.search.trim()
        });
    }

    getCountryOptions = () => {
        return COUNTRY.map(country => ({
            value: country.countryCode,
            label: country.countryName
        }));
    }

    handleCorporateSearchClick = (e) => {
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
        this.setState({
            submitted: false,
            select: "Name",
            isUser: false,
            searchSelected: "Corporate"
        });
        this.searchCriteriaDataItems = ["Name", "GST", "City"];
        this.searchPlaceholder = "Search Name";
        this.searchCriteriaDataItems.map((item, index) => {
            return (this.searchCriteriaItems.push(<DropdownItem onClick={this.onhandleSelected} value={item} key={index}>{item}</DropdownItem>))
        });
        this.setState({
            modalTitle: "Corporate name",
            body: <div className="modal-body">
                <TableView selected={StringConst.CORPORATE_LABEL} />
                <Button color="primary" className="mr-1 mt-3" onClick={this.selectCorporatre}>Done</Button>
                <Button color="secondary" className="mr-1 mt-3" onClick={this.handleModal}>Cancel</Button>
            </div>,
            inputField: "corporateSearch"
        })
        this.handleModal()
    }
    selectCorporatre = () => {
        this.props.change('corporate', this.props.selectedCorp.corporateName);
        this.props.corporateResults([])
        this.handleModal()
    }

    handleCounterpartySearchClick = (e) => {
        this.searchCriteriaDataItems = [];
        this.searchCriteriaItems = [];
        this.setState({
            submitted: false,
            select: "Name",
            isUser: false,
            searchSelected: "Counterparty",
            disabled: true
        });
        this.searchCriteriaDataItems = ["Name", "GST", "PAN", "CIN"];
        this.searchPlaceholder = "Search Name";
        this.searchCriteriaDataItems.map((item, index) => {
            return (this.searchCriteriaItems.push(<DropdownItem onClick={this.onhandleSelected} value={item} key={index}>{item}</DropdownItem>))
        });
        this.setState({
            modalTitle: "Counterparty name",
            body: <div className="modal-body">
                <TableView selected={StringConst.COUNTER_PARTY_LABEL} />
                <div><Button className="mr-1 mt-3" onClick={this.handleNotAvailable}>Not Available</Button>
                    <Button color="primary" className="mr-1 mt-3" onClick={this.selectCounterparty}>Done</Button>
                    <Button color="secondary" className="mr-1 mt-3" onClick={this.handleModal}>Cancel</Button></div>
            </div>,
            inputField: "counterpartySearch"
        })
        this.handleModal()
    }

    selectCounterparty = () => {
        
        this.props.change('counterparty', this.props.selectedCounterparty.counterpartyName);
        this.props.counterpartyResults([])
        this.handleModal()
        this.props.getZoneForState(this.props.selectedCounterparty.state);
        this.setProductCategory();
    }
    setProductCategory= () => {
        let cinNumber=this.props.counterparty[0].cinNo
        let gstNumber=this.props.counterparty[0].gstNo
        let panNumber=this.props.counterparty[0].panNo
       if(this.props.formValues.values.caseType=== StringConst.DOMESTIC){
       if((cinNumber && cinNumber!=="Not Applicable/Available" && cinNumber!=="Not Available" && cinNumber!=="Not Applicable") ||
       (gstNumber && gstNumber.charAt(5)==='C')|| (panNumber && panNumber.charAt(3)==='C') ) {
           this.state.selectedProductCategory="CORPORATE"
        }
        else{
            this.state.selectedProductCategory="NON_CORPORATE"
        }
    }
    else{
        this.state.selectedProductCategory="INTERNATIONAL"
    }
    }
    handleNotAvailable = () => {
        this.setState({
            submitted: true,
            body: <AddCounterPartyForm closeModal={this.handleModal} caseType={this.props.formValues.values.caseType} />
        })
    }
    handleUserSearchClick = () => {
        this.setState({
            submitted: false,
            isUser: true,
            searchSelected: "User"
        });

        this.setState({
            modalTitle: "Requested by user",
            body:
                <div className="modal-body">
                    <TableView selected={StringConst.USER_LABEL} />
                    <div>
                        <Button color="primary" className="mr-1 mt-3" onClick={this.selectUser}>Done</Button>
                        <Button color="secondary" className="mr-1 mt-3" onClick={this.handleModal}>Cancel</Button></div>
                </div>,
            inputField: "userSearch"
        })
        this.searchPlaceholder = "Search by Firstname or Lastname";
        this.handleModal()
    }
    selectUser = () => {
        this.props.change('requestedBy', this.props.selectedUser.username)
        this.handleModal()
        this.props.userResults([])
    }
    mySubmitHandler = (data) => {
        const { selProduct, selectedCorp, createdCounterParty, selectedCounterparty, selectedUser} = this.props
        this.case = {
            "productId": selProduct.id,
            "corporateId": selectedCorp.id,
            "counterpartyId": createdCounterParty.id ? createdCounterParty.id : selectedCounterparty.id,
            "counterpartyType": data.counterpartytype,
            "requestedById": selectedUser.id,
            "misOrderId":  this.props.formValues.values.misOrderId,
            "requestedByUserName": selectedUser.username,
            "zoneId": (this.props.formValues.values.caseType === StringConst.DOMESTIC) ? ((this.props.zoneFromState && this.props.zoneFromState.id)? this.props.zoneFromState.zoneId : data.zone ): null,
            "caseType": this.props.formValues.values.caseType,
            "requestType":this.props.formValues.values.requestType ? "API" : "NORMAL",
            "participantName": this.props.formValues.values.participantName,
            "participantAadhaarNo": this.props.formValues.values.participantAadhaarNo,
            "bankAccountNumber": this.props.formValues.values.participantCompanyBankAccountNo,
            "bankIfscCode": this.props.formValues.values.participantCompanyBankIfscCode,
            "address": this.props.formValues.values.participantCompanyAddress,
            "kycType": this.props.formValues.values.kycType ? this.props.formValues.values.kycType : StringConst.EKYC,
            "participantPanNo": this.props.formValues.values.participantPanNo,
            "participantPhone": this.props.formValues.values.participantPhone,
            "participantEmail": this.props.formValues.values.participantEmail,
            "isKycRequest": this.props.formValues.values.isKycRequest,
            "meetingDate": this.props.formValues.values.meetingDate,
            "meetingTime": this.props.formValues.values.meetingTime,
        }
        this.props.createCase(this.case)
        this.props.preloading(true)
    }



    search = (param) => {
        if (this.state.searchSelected === StringConst.COUNTER_PARTY_LABEL && !this.state.search.trim()) {
            return;
        }
        this.props.preloading(true)
        this.setState({ resizeZIndex: true })
        if (this.state.searchSelected === StringConst.CORPORATE_LABEL)
            this.props.setSearchCorporateParameter(
                this.state.select,
                this.state.search);
        else if (this.state.searchSelected === StringConst.COUNTER_PARTY_LABEL) {
            const selectedCountry = this.props.formValues.values.caseType === StringConst.INTERNATIONAL ? this.state.selectedCountry : null;
            this.props.setSearchCounterpartyParameter(
                this.state.select,
                this.state.search.trim(),
                selectedCountry ? selectedCountry.value : null,
                selectedCountry ? selectedCountry.label : null,
                1,
                this.props.counterpartyPageSize || 10,
                this.props.formValues.values.caseType);
        }
        else if (this.state.searchSelected === StringConst.USER_LABEL) {
            this.props.getUsers(
                this.props.selectedCorp.id,
                this.state.search);
        }
    }
    handleCaseTypeChange = (event) => {
        this.props.change('caseType', event.target.value)
        if (event.target.value === StringConst.DOMESTIC) {
            this.props.change('country', { id: 'IN', value: 'India' })
            this.setState({ selectedCountry: '' })
        } else {
            this.props.change('country', '')
        }
    }

    handleKycCheckBoxChange = (event) => {
        //Toggle kycRequest state via checkbox tick event
        this.state.isKycRequest = !(this.state.isKycRequest);
        
    }

    handleKycRequestTypeDropDownChange = (event) => {
        this.state.kycRequestType = event.target.value;
    };
    searchCallback = (selected, type) => {
        this.props.change('country', selected)
    }
    render() {
        const { handleSubmit } = this.props;
        const { value } = this.state;
        let dropdown
        let search
        let modalHeader
        let caseTypeFlag
        const isInternationalCounterpartySearch = this.props.formValues && this.props.formValues.values &&
            this.props.formValues.values.caseType === StringConst.INTERNATIONAL &&
            this.state.searchSelected === StringConst.COUNTER_PARTY_LABEL;
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        };
      
        
        if (this.props.formValues) {
            if (this.props.formValues.values) {
                if (this.props.formValues.values.caseType === StringConst.DOMESTIC) {
                    caseTypeFlag = StringConst.DOMESTIC;
                    inputProps.disabled = true;
                } else {
                    caseTypeFlag = StringConst.INTERNATIONAL;
                    inputProps.disabled = false;
                    this.state.selectedProductCategory="INTERNATIONAL"
                }
            }
        }
        if (this.state.submitted === false) {
            dropdown = (this.state.isUser || isInternationalCounterpartySearch) ? "" : <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle caret>
                    {this.state.select}
                </DropdownToggle>
                <DropdownMenu>
                    {this.searchCriteriaItems}
                </DropdownMenu>
            </Dropdown>;

            modalHeader = <div className="modal-header row pt-0">
                <h5 className="mb-0">{this.state.modalTitle}</h5>
                <button type="button" onClick={this.handleModal} className="close outline-none" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>;

            search = <div className='d-flex ml-4 mr-4 mt-2'>
                {isInternationalCounterpartySearch &&
                    <div className="country-filter">
                        <Select
                            value={this.state.selectedCountry}
                            onChange={this.handleCountryChange}
                            options={this.getCountryOptions()}
                            isClearable={true}
                            placeholder="Search Country" />
                    </div>
                }
                {dropdown}
                <Input type="text" name={this.state.inputField} value={this.state.search} 
                    id="corporate_search" placeholder={isInternationalCounterpartySearch ? "Search Counterparty Name" : this.searchPlaceholder}
                    className={isInternationalCounterpartySearch ? "ml-4" : ""}
                    onChange={this.handleInputChange} />
                <Button color="primary" className="ml-4" disabled={this.state.disabled} onClick={this.search}>
                    <i className="fa fa-search fa-fw"></i> Search
            </Button>
            </div>
        }
        return (
            <CardBody className='mb-70'>
                <Form className="w-75" onChange={this.handleFormChange} onSubmit={handleSubmit((val) => { this.mySubmitHandler(val) })} autoComplete="on">
                    <div>
                        <label>Case Type</label>
                        <div>
                            <label>
                                <Field name="caseType" component="input" type="radio" value={StringConst.DOMESTIC} onChange={this.handleCaseTypeChange} />{' '}
                                Domestic
                            </label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label>
                                <Field name="caseType" component="input" type="radio" value={StringConst.INTERNATIONAL} onChange={this.handleCaseTypeChange} />{' '}
                                International
                             </label>
                        </div>
                        &nbsp;
                    </div>
                    <Field
                        name="corporate"
                        className="form-control"
                        type="text"
                        validate={[required,isValid]}
                        component={renderField}
                        label="Corporate"
                        placeholder="Search and Select a Corporate"
                        onclick={this.handleCorporateSearchClick} />
                    <Field
                        name="requestedBy"
                        className="form-control"
                        type="text"
                        validate={[required]}
                        component={renderField}
                        label="Requested By"
                        placeholder="Search and Select a Corporate User"
                        onclick={this.handleUserSearchClick} />
                    <Field
                        name="counterparty"
                        className="form-control"
                        type="text"
                        validate={[required]}
                        component={renderField}
                        label="Counterparty"
                        placeholder="Search and Select a Counterparty"
                        onclick={this.handleCounterpartySearchClick}
                        dis={(!caseTypeFlag) ? true : false} />
                    <FormGroup>
                        <Label>Counterparty Type</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="counterpartytype"
                                    // component="select"
                                    label="dropDownSelect"
                                    component={DropDownSelect}
                                    validate={[required]}
                                    className="form-control"
                                    data={this.props.counterpartyType}
                                    dis={false}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Label>Product</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="product"
                                    // component="select"
                                    label="dropDownSelect"
                                    component={DropDownSelect}
                                    validate={[required]}
                                    className="form-control"
                                    data={this.state.products}
                                    dis={this.state.productDisabled}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Label>MIS Order Id</Label>
                        <Row>
                            <Col>
                                <Field
                                 name="misOrderId"
                                 className="form-control"
                                 type="text"
                                 validate={this.props.isMisOrderIdMandatory?[required]:[]}  
                                 component={commonRenderField}
                                 label="Mis Order Id"
                                 placeholder="Mis Order Id" >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>


                    {(caseTypeFlag === StringConst.DOMESTIC) ?
                        <FormGroup>
                            <Label>Zone</Label>
                            <Row>
                                <Col>
                                { (this.props.zoneFromState && this.props.zoneFromState.zone) ?(
                            <input
                                name="zone"
                                component="input"
                                label="dropDownSelect"
                               // component={Dropdown}
                                validate={this.state.validation}
                                className="form-control"
                                value={this.props.zoneFromState.zone}
                                data={this.props.zoneList}
                                readOnly ={true}
                                dis={false}
                              //  selectedZone={this.props.zoneSelected.zone}
                            >
                            </input>
                            ):
                                    <Field
                                        name="zone"
                                        label="dropDownSelect"
                                        component={DropDownSelect}
                                        validate={[required]}
                                        className="form-control"
                                        data={this.props.zoneList}
                                        dis={false} />
                                }
                                </Col>
                            </Row>
                        </FormGroup> : null
                    }

                    
                    {(caseTypeFlag === StringConst.DOMESTIC) ?
                        <FormGroup>
                            <div>
                                <label>&nbsp;&nbsp;
                                    <Field name="isKycRequest" component="input" type="checkbox" onChange={this.handleKycCheckBoxChange} />
                                    &nbsp;&nbsp; Kyc Request?
                                </label>
                            </div>
                        </FormGroup> : null
                    }

                    {/* for Kyc related cases we need to consider some additional fields */}
                    {(this.state.isKycRequest) ?
                        (<div>

                            <FormGroup>
                                <Label>Kyc Request Type</Label>
                                <Row>
                                    <Col>
                                        <Field name="kycType" value={this.kycRequestType} component="select" className="form-control dropdown-counterparty border" onChange={this.handleKycRequestTypeDropDownChange}>
                                            <option value='EKYC'>EKYC</option>
                                            <option value='VKYC'>VKYC</option>
                                        </Field>
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Participant Name.</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantName"
                                            className="form-control"
                                            validate={[required,isValid]}
                                            type="text"
                                            component={commonRenderField}
                                            label="participant name"
                                            placeholder="participant name"
                            
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Participant Aadhaar No.</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantAadhaarNo"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant name"
                                            placeholder="Participant Aadhaar No."
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Label>Participant Pan No.</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantPanNo"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant pan no"
                                            placeholder="Participant Pan No."
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Participant Bank Account No.</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantCompanyBankAccountNo"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant bank account no"
                                            placeholder="Participant Bank Account No."
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Participant Bank IFSC Code</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantCompanyBankIfscCode"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant bank ifsc code"
                                            placeholder="Participant Bank Ifsc Code"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Address</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantCompanyAddress"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="Address"
                                            placeholder="Address"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Email</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantEmail"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant email"
                                            placeholder="Participant Email"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Label>Participant Phone</Label>
                                <Row>
                                    <Col>
                                        <Field
                                            name="participantPhone"
                                            className="form-control"
                                            type="text"
                                            component={commonRenderField}
                                            validate={[isValid]}
                                            label="participant phone"
                                            placeholder="Participant phone"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            {(this.state.kycRequestType === StringConst.VKYC) ?
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Field
                                                name="meetingDate"
                                                className="form-control"
                                                type="date"
                                                label="Meeting Date"
                                                validate={[required]}
                                                readOnlyValue = {false}
                                                component={renderField}
                
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup> : null
                            }

                            {
                                (this.state.kycRequestType === StringConst.VKYC ?
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Field
                                                    name="meetingTime"
                                                    className="form-control"
                                                    type="time"
                                                    label="Meeting Time"
                                                    validate={[required]}
                                                    readOnlyValue = {false}
                                                    component={renderField}
                                         
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup> : null)
                            }

                            
                            </div>) :

                        null
                    }

                    {this.props.formValues && this.props.formValues.values && this.props.formValues.values.caseType !== StringConst.DOMESTIC &&
                        <div>
                            <label>&nbsp;&nbsp;
                            <Field name="requestType" component="input" type="checkbox" />
                            &nbsp;&nbsp;Is API Case?
                            </label>
                        </div>
                    }

                    <FormGroup className="text-right">
                        <Button color="primary" type="submit" id="caseSubmit">Submit</Button>
                    </FormGroup>
                </Form>
                <Modal show={this.state.showModal} className={this.state.resizeZIndex ? 'z-index-zero Large-Modal modal-content' : 'Large-Modal modal-content'} modalClosed={this.handleModal} >
                    {modalHeader}
                    {search}
                    {this.state.body}
                </Modal>
            </CardBody >
        )
    }
}
  
const renderField = ({ className, input, label, type, dis, placeholder, onclick,readOnlyValue,
    meta: { touched, error, warning } }) => {

    return (

        <FormGroup>
            <Label>{label}&nbsp;<span className="text-danger">*</span></Label>
            <Row>
                <Col>
                    <input {...input} disabled={dis} onClick={onclick} placeholder={placeholder} type={type} className={className} required readOnly={readOnlyValue == false ? false : true} />
                    {touched && ((error && <span className="error text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
                </Col>
            </Row>
        </FormGroup>

    )
}
const commonRenderField = ({ className,input, label, type, isRequired, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col>
            <input {...input} placeholder={label} type={type} className={className} />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)

const required = value => value ? null : 'Required';

const isValid = value => !value||value.match(/^[^<>!$%^?*~`{}=]*$/) ? null :'Please enter valid Input';

const mapStateToProps = (state, ownProps) => ({
    selectedCorp: state.createCase.selectedCorporate,
    selectedCounterparty: state.createCase.selectedCounterparty,
    createdCounterParty: state.createCase.createdCounterParty,
    counterpartyType: state.createCase.dropdownData,
    // selectedDropdown: state.form.CaseCreateForm,
    products: state.createCase.products/*  */,
    productsFailure: state.createCase.productsFailure,
    selProduct: state.createCase.selectedProduct,
    result: state.createCase.result,
    createCounterParty: state.createCase.createCounterParty,
    selectedUser: state.createCase.selectedUser,
    zoneList: state.createCase.zoneList,
    formValues: state.form.CaseCreateForm,
    corporate: state.createCase.corporate,
    counterparty: state.createCase.counterparty,
    counterpartyPageNo: state.createCase.counterpartyPageNo,
    counterpartyPageSize: state.createCase.counterpartyPageSize,
    counterpartyHasNext: state.createCase.counterpartyHasNext,
    counterpartyLoading: state.createCase.counterpartyLoading,
    isMisOrderIdMandatory: state.corporateOnBoardingCreate.fetchIsMisOrderIdMandatorySuccess,
    users: state.createCase.users,
    zoneFromState: state.createCase.zoneForState,
    
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    createCase: (data) => { dispatch(caseCreateActions.createCase(data)); },
    getCounterpartyType: () => { dispatch(caseCreateActions.getCounterpartyType()); },
    getProducts: (id, type,selectedProductCategory) => { dispatch(caseCreateActions.getProducts(id, type,selectedProductCategory)); },
    selectedProduct: (data) => { dispatch(caseCreateActions.selectedProduct(data)); },
    clearData: () => { dispatch(caseCreateActions.clearData()); },//clearCounterParty
    clearCounterParty: () => { dispatch(caseCreateActions.clearCounterParty()); },
    getUsers: (id, search) => { dispatch(caseCreateActions.getUsers(id, search)); },
    setSearchCorporateParameter: (param, search) => { dispatch(caseCreateActions.setSearchCorporateParameter(param, search)); },
    setSearchCounterpartyParameter: (param, search, countryCode, countryName, pageNo, pageSize, caseType) => { dispatch(caseCreateActions.setSearchCounterpartyParameter(param, search, countryCode, countryName, pageNo, pageSize, caseType)) },
    resetCounterpartyPagination: () => { dispatch(caseCreateActions.resetCounterpartyPagination()) },
    clearResult: () => { dispatch(caseCreateActions.clearResult()); },
    getZone: () => { dispatch(caseCreateActions.getZone()) },
    userResults: () => { dispatch(caseCreateActions.getUsersSuccess()) },
    corporateResults: () => { dispatch(caseCreateActions.searchCorporateResultsSuccess()) },
    counterpartyResults: () => { dispatch(caseCreateActions.searchCounterpartyResultsSuccess()) },
    getZoneForState :(state) =>{dispatch(caseCreateAction.getZoneForState(state))},
    fetchIsMisOrderIdMandatoryByCorporateId: (data) => { dispatch(fetchIsMisOrderIdMandatoryByCorporateId(data)) },
    preloading: (status) => { dispatch(Preloading(status)) },
});
//CaseCreateForm=connect(mapDispatchToProps, mapStateToProps)(CaseCreateForm)

export default reduxForm({
    form: 'CaseCreateForm'
})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CaseCreateForm)))//
